/**
 * Generated by orval v8.16.0 🍺
 * Do not edit manually.
 * FinPath API
 * Backend API programu FinPath (panel admina + aplikacja mobilna).
 * OpenAPI spec version: 0.1.0
 */

/**
 * * `1` - 1
 * * `2` - 2
 */
export type OrdinalEnum = typeof OrdinalEnum[keyof typeof OrdinalEnum];


export const OrdinalEnum = {
  NUMBER_1: 1,
  NUMBER_2: 2,
} as const;
